export default __webpack_public_path__ + "static/media/arrow-down-primary.9fd0dd51.svg";